<template>
    <div id="ProfileHighlightsDescription" :class="minified ? 'mt-2.5 left-0' : ''">
        <p :class="minified ? 'mb-0.5' : 'mb-0.5 sm:mb-2'" :variant="minified ? '4' : '2'">
            <strong>{{ descriptionTitle }}</strong>
        </p>

        <span :class="minified ? 'pb-1' : 'pb-1 sm:pb-0'" v-html="description" />
    </div>
</template>

<script setup lang="ts">
defineProps({
    descriptionTitle: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    minified: {
        type: Boolean,
        default: false
    }
})
</script>